/**
 * Ensure prefix of a string
 * @category String
 */
export function ensurePrefix(prefix: string, str: string) {
	if (!str.startsWith(prefix)) return prefix + str;
	return str;
}

/**
 * Ensure suffix of a string
 * @category String
 */
export function ensureSuffix(suffix: string, str: string) {
	if (!str.endsWith(suffix)) return str + suffix;
	return str;
}

const CAPITALIZE_FIRST_LETTER_REGEX = /^\p{CWU}/u;

/**
 * Capitalizes the first letter of a given string according to the specified locale.
 *
 * @param str - The string to be capitalized.
 * @param locale - The locale to use for capitalization.
 * @returns {string} The string with the first letter capitalized according to the specified locale.
 * @category String
 */
export function capitalizeLocalisedFirstLetter(str: string | undefined, locale: string) {
	if (!str) return '';

	return str.replace(CAPITALIZE_FIRST_LETTER_REGEX, (char) => char.toLocaleUpperCase(locale));
}
